import React from "react";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import { useImportActivities } from "../../../../backend/masters";
import { download, preventDefault } from "../../../../utils/common";
import { componentTypes } from "../../../common/FormRenderer";
import { EXCEL_FILE_REGEX, FILE_SIZE } from "../../../common/Constants";
import BaseImportModal from "../../../common/BaseImportModal";

function ActivitiesImportModal({ onClose }: any) {

    const schema = {
        fields: [
            {
                component: componentTypes.FILE_UPLOAD,
                label: 'Upload File',
                name: 'file',
                type: 'file',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: 'file-type', regex: EXCEL_FILE_REGEX },
                    { type: 'file-size', maxSize: 25 * FILE_SIZE.MB }
                ],
                description: <a href="/" onClick={downloadSample}>Dowload Sample Activities</a>
            },
        ],
    };

    function downloadSample(e: any) {
        preventDefault(e);
        download('Sample Activities.xlsx', 'https://mafoi.s3.ap-south-1.amazonaws.com/bulkuploadtemplates/ActivitiesTemplate.xlsx')
    }

    return (
        <BaseImportModal onClose={onClose} importSchema={schema} importFunction={useImportActivities} title="Import Activities" />
    )
}

export default ActivitiesImportModal;
